import { render, staticRenderFns } from "./GTrimString.vue?vue&type=template&id=4b54406e&"
import script from "./GTrimString.vue?vue&type=script&lang=ts&"
export * from "./GTrimString.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports